import { Pencil, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";

/** The edit and delete pair every catalogue row carries, on a table or a card. */
export function RowActions({
  onEdit,
  onDelete,
  editLabel = "Modifier",
  deleteLabel = "Supprimer",
}: {
  onEdit: () => void;
  onDelete: () => void;
  editLabel?: string;
  deleteLabel?: string;
}) {
  return (
    <div className="flex items-center gap-1">
      <Button type="button" variant="ghost" size="icon-sm" aria-label={editLabel} title={editLabel} onClick={onEdit}>
        <Pencil className="text-muted-foreground" />
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={deleteLabel}
        title={deleteLabel}
        onClick={onDelete}
      >
        <Trash2 className="text-destructive" />
      </Button>
    </div>
  );
}
